import { render, staticRenderFns } from "./FormModalRoomDetail.vue?vue&type=template&id=04be2829&scoped=true&"
import script from "./FormModalRoomDetail.vue?vue&type=script&lang=js&"
export * from "./FormModalRoomDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormModalRoomDetail.vue?vue&type=style&index=0&id=04be2829&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be2829",
  null
  
)

export default component.exports